import * as React from 'react';

import Checkbox from 'components/form/fields/Checkbox/Checkbox';
import Editor from 'components/form/fields/Editor/Editor';
import TextInput from 'components/form/fields/TextInput/TextInput';
import { slugNormalizer } from 'core/helpers/normalizers';
import createDecorator from 'final-form-calculate';
import { checkSlugs } from '../articles-form/redux';
import { toast } from 'react-toastify';
import { createSelector } from 'reselect';

export const gridConfig = {
  columns: [
    {
      name: 'title',
      title: 'Title',
    },
    {
      component: ({ value }: any) => <span>{value ? 'yes' : 'no'}</span>,
      name: 'isPublished',
      title: 'Published',
    },
  ],
  title: 'Categories',
};

export const formConfig = {
  fields: [
    {
      component: TextInput,
      isRequired: true,
      name: 'title',
      title: 'Title',
      translatable: true,
    },
    {
      component: Checkbox,
      name: 'isPublished',
      roles: ['admin', 'superadmin'],
      title: 'Is published',
    },
    {
      component: TextInput,
      isRequired: true,
      name: 'slug',
      normalizer: slugNormalizer,
      title: 'Slug',
    },
    {
      component: Checkbox,
      name: 'isSlugNotSynchronized',
      title: 'Do not synchronize the slug and the title',
    },
    {
      component: Editor,
      name: 'description',
      title: 'Description',
      translatable: true,
      isRequired: true,
    },
  ],
  title: 'Category',
  withPermission: true,
};

const slugsDecorator = (initialValues: any) =>
  createDecorator(
    {
      field: 'title',
      updates: {
        slug: async (
          value: string,
          allValues: any,
          prevValues: any,
        ): Promise<string> => {
          const slug =
            allValues.isSlugNotSynchronized ||
            !prevValues.hasOwnProperty('slug')
              ? allValues.slug
              : await slugNormalizer(value);

          if (slug === initialValues.slug) {
            return slug;
          }
          try {
            const { data } = await checkSlugs(slug);

            if (Array.isArray(data)) {
              return data[0];
            }
          } catch (error) {
            if (error.message !== '404') {
              toast.error(error.message);
            }
          }

          return slug;
        },
      },
    },
    {
      field: 'isSlugNotSynchronized',
      updates: {
        slug: (value: string, allValues: any): string => {
          return value ? allValues.slug : slugNormalizer(allValues.title);
        },
      },
    },
  );

export const decorators = createSelector(
  initialValues => initialValues,
  (initialValues: any) => [slugsDecorator(initialValues)],
);
